import { css } from "styled-components"

export const FontFamilyRegular = css`
  font-family: "HCo Gotham", "Helvetica", "Verdana", "Arial", "sans-serif";
`

type TFontWeight = string | number | TemplateStringsArray

const info = (weight, size) => {
  return css`
    ${FontFamilyRegular}
    font-size: ${size};
    font-style: normal;
    font-weight: ${weight};
    line-height: 170%;
    color: var(--body-text-grey);
  `
}
info.sm = (weight: TFontWeight) => info(weight, "14px")
info.md = info.sm
info.lg = info.sm

// Body text
const body = (weight, size) => {
  return css`
    ${FontFamilyRegular}
    font-size: ${size};
    font-style: normal;
    font-weight: ${weight};
    line-height: 170%;
    color: var(--body-text-grey);
  `
}
body.sm = (weight: TFontWeight) => body(weight, "17px")
body.md = (weight: TFontWeight) => body(weight, "18px")
body.lg = body.md

// Header1
const h1 = (weight, size) => {
  return css`
    ${FontFamilyRegular}
    font-size: ${size};
    font-style: normal;
    font-weight: ${weight};
    line-height: 120%;
    color: var(--slate);
  `
}
h1.sm = (weight: TFontWeight) => h1(weight, "30px")
h1.md = (weight: TFontWeight) => h1(weight, "36px")
h1.lg = h1.md

// Header 2
const h2 = (weight, size) => {
  return css`
    ${FontFamilyRegular}
    font-size: ${size};
    font-style: normal;
    font-weight: ${weight};
    line-height: 140%;
    color: var(--slate);
  `
}
h2.sm = (weight: TFontWeight) => h2(weight, "24px")
h2.md = (weight: TFontWeight) => h2(weight, "30px")
h2.lg = h2.md

// Header 3
const h3 = (weight, size) => {
  return css`
    ${FontFamilyRegular}
    font-size: ${size};
    font-style: normal;
    font-weight: ${weight};
    line-height: 140%;
    color: var(--slate);
  `
}
h3.sm = (weight: TFontWeight) => h3(weight, "20px")
h3.md = (weight: TFontWeight) => h3(weight, "24px")
h3.lg = h3.md

// Header4
const h4 = (weight, size) => {
  return css`
    ${FontFamilyRegular}
    font-size: ${size};
    font-style: normal;
    font-weight: ${weight};
    line-height: 140%;
    color: var(--slate);
  `
}
h4.sm = (weight: TFontWeight) => h4(weight, "18px")
h4.md = (weight: TFontWeight) => h4(weight, "20px")
h4.lg = h4.md

/** Blog Typography Object*/
export const BT = {
  /** Mobile Blog Styles */
  sm: {
    info: info.sm,
    body: body.sm,
    h1: h1.sm,
    h2: h2.sm,
    h3: h3.sm,
    h4: h4.sm,
  },
  /** Tablet Blog Styles */
  md: {
    info: info.md,
    body: body.md,
    h1: h1.md,
    h2: h2.md,
    h3: h3.md,
    h4: h4.md,
  },
  /** Desktop Blog Styles */
  lg: {
    info: info.lg,
    body: body.lg,
    h1: h1.lg,
    h2: h2.lg,
    h3: h3.lg,
    h4: h4.lg,
  },
}
